import { useState } from 'react';
import { LogOutIcon } from 'smoothie';

import { SmallTileButton } from '../../common/components/GroveButtons';
import { useLogout } from '../hooks/useLogout';
import { LogoutType } from '../types/auth';

export const SignOutButton = () => {
    const { logOut } = useLogout();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const handleSignOut = () => {
        setIsLoggingOut(true);
        void logOut(LogoutType.LogoutButton);
    };

    return (
        <SmallTileButton
            icon={LogOutIcon}
            label="Sign out"
            onPress={handleSignOut}
            isWaiting={isLoggingOut}
        />
    );
};
